/**
 * SignalR 業務事件名（後端 SendAllAsync/SendAsync 推送、前端 on() 監聽）。
 * 後端對應字串請與此保持同步;裸字串打錯不會編譯報錯、執行時靜默收不到,故集中於列舉。
 * @readonly
 * @enum {string}
 */
enum hubMethod$ {
    // ── 排程監控 ──
    /** 排程即時事件(增量;ScheduleEventDto) */
    scheduleEvent = 'onScheduleEvent',
    /** 排程快照(基底;ScheduleSnapshotPayload) */
    scheduleSnapshot = 'onScheduleSnapshot',
    /** roster 單筆更新(設定變更;ScheduleRosterUpdate) */
    rosterUpdate = 'onRosterUpdate',

    // ── 通訊 ──
    /** 通道更新(CommChannel) */
    channelUpdate = 'onChannelUpdate',
    /** 指標更新(CommMetrics) */
    receiveMetrics = 'onReceiveMetrics',
    /** 主機指標(HostMetrics) */
    hostMetrics = 'onHostMetrics',
    /** 通訊快照(CommSnapshot) */
    commSnapshot = 'onSnapshot',
    /** WebRTC 統計全量廣播(WebRTCStats) */
    webRtcStats = 'onWebRTCStats',
    /** WebRTC 統計快照回應(WebRTCStats，對單一連線) */
    webRtcStatsSnapshot = 'onWebRTCStatsSnapshot'
}

/**
 * Hub Handler 名稱（後端 [HubFunc] 所屬的 Handler 類別名;notify/inquire 第一參數）。
 * 命名原則:呼叫的目標是後端 C# class,故用 .NET 命名法（PascalCase），與後端 class 名逐字相同
 * （前端字串可直接對應/搜尋到後端 class，雙向可追溯）。
 * @readonly
 * @enum {string}
 */
enum hubHandler$ {
    /** SignalR Hub 與腳本之間的通用閘道（RequestSnapshot 等 [HubFunc]，所有業務頁共用） */
    hubGateway = 'HubGateway'
}

/**
 * Hub Function 名稱（後端 [HubFunc] 方法名;notify/inquire 第二參數）。
 * 命名原則:呼叫的目標是後端 C# method,故用 .NET 命名法（PascalCase），與後端方法名逐字相同。
 * @readonly
 * @enum {string}
 */
enum hubFunc$ {
    /** 請求快照(觸發後端推 snapshot) */
    requestSnapshot = 'RequestSnapshot'
}

export { hubMethod$, hubHandler$, hubFunc$ };